import React, { useState } from 'react';
import * as Yup from 'yup';
import {
  Formik,
  Form as FormikForm,
  FieldArray,
  useFormikContext,
} from 'formik';
import CurrencyPrice from 'components/PolicyPlans/Fields/CurrencyPrice';
import {
  Form as BaseForm,
  TextField,
  CheckBoxField,
  SubmitButton,
  CancelPopupButton,
} from '../../../../ui/FormElement';
import { usePolicyPlanCustomRecordTemplateContext } from '../../../../contexts/PolicyPlanCustomRecordTemplateContext';

export default function Form() {
  const FormSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    currency_prices: Yup.array().of(
      Yup.object().shape({
        currency: Yup.string().required('required'),
        price: Yup.number().required('required'),
      }),
    ),
  });

  const [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = usePolicyPlanCustomRecordTemplateContext();

  const [formData, setFormData] = useState(
    state.currentTemplate == null
      ? {
        name: '',
        required_for_manager: true,
        currency_prices: [
          {
            currency: 'USD',
            price: '',
          },
          {
            currency: 'CAD',
            price: '',
          },
          {
            currency: 'GBP',
            price: '',
          },
          {
            currency: 'CHF',
            price: '',
          },
        ],
      }
      : {
        name: state.currentTemplate.attributes.name,
        required_for_manager: state.currentTemplate.attributes.required_for_manager,
        currency_prices: state.currentTemplate.attributes.currency_prices,
      },
  );

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.save(
      dispatch,
      state.currentTemplate == null ? 0 : parseInt(state.currentTemplate.id),
      values,
      () => {
        setLoader(false);
        actions.hideModal(dispatch);
        actions.load(dispatch);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="name"
        label={(
          <>
            <span>Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <CurrencyPrice isReadonly={false} showDeleteButton={false} showAddButton={false} />

      <CheckBoxField
        name="required_for_manager"
        inline
        label={(
          <span>Required For Manager</span>
                  )}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? 'Please, wait ...' : 'Save'}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? 'not-possible-click' : ''
          }`}
        />
      </div>
    </BaseForm>
  );
}
